import { connection } from '../socket';
export const SET_GAMESTEP = 'gameStep/SET_GAMESTEP';
export const SET_GAMESTEP_SUBMITTING = 'gameStep/SET_GAMESTEP_SUBMITTING';
export const CLEAR_GAMESTEP_SUBMITTING = 'gameStep/CLEAR_GAMESTEP_SUBMITTING';

// A submit the server never answers (lost on a reconnect, or a no-op) must not leave buttons disabled.
export const SUBMIT_TIMEOUT_MS = 5000;

// Clears the submitting flag; with a token, only if it still belongs to that submit.
export const clearSubmitting = token => ({
  type: CLEAR_GAMESTEP_SUBMITTING,
  payload: {
    token
  }
});
export const receiveGameStep = payload => async dispatch => {
  dispatch({
    type: SET_GAMESTEP,
    payload
  });
};
export const clearGameStep = () => async dispatch => {
  dispatch({
    type: SET_GAMESTEP,
    payload: null
  });
};
export const submitGameStep = (id, data = {}, actions = {}) => (dispatch, state) => {
  if (state().gameStep?.gameStep?._id !== id) return;
  dispatch({
    type: SET_GAMESTEP_SUBMITTING
  });
  const token = state().gameStep.submitting;
  setTimeout(() => dispatch(clearSubmitting(token)), SUBMIT_TIMEOUT_MS);
  const payload = {
    id,
    data: data || {},
    actions
  };
  connection.socket.emit('submit-step', payload);
};
export const updateGameStep = (id, data = {}, actions = {}) => {
  const payload = {
    id,
    data: data || {},
    actions
  };
  connection.socket.emit('update-step', payload);
};